import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';
class Dashboard extends Component {
	componentDidMount() {
		this.props.setHome();
	}
	render() {
		return (
			<div>
				<Link to="/">
					<Button
						variant="outline-danger"
						onClick={() => {
							localStorage.clear();
							this.props.history.push('/');
							window.location.reload();
						}}
					>
						Logout
					</Button>
				</Link>
				<Link to="/edit">
					<Button variant="outline-info">Change Password</Button>
				</Link>
			</div>
		);
	}
}

export default withRouter(Dashboard);
